import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArticleCard } from "@/components/public/ArticleCard";

export default function Author() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { window.scrollTo(0,0); api.get(`/authors/${slug}`).then((r) => setA(r.data)).catch(() => {}); }, [slug]);
  if (!a) return <div className="max-w-3xl mx-auto px-6 py-24 text-mutedink">Loading…</div>;
  return (
    <div className="max-w-[1000px] mx-auto px-4 sm:px-6 py-10">
      <div className="border border-hair p-8 bg-surface">
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink">{a.name}</h1>
        <div className="text-xs uppercase tracking-widest text-crimson font-bold mt-2">{a.role}</div>
        <p className="text-ink2 leading-relaxed mt-4 max-w-2xl">{a.bio}</p>
        {a.expertise?.length > 0 && <div className="mt-4 flex flex-wrap gap-2">{a.expertise.map((e) => <span key={e} className="text-xs bg-subtle px-2.5 py-1 text-ink2">{e}</span>)}</div>}
      </div>
      <div className="mt-12">
        <div className="border-b-2 border-ink pb-2 mb-6"><h2 className="font-serif font-bold text-2xl">Articles by {a.name}</h2></div>
        {a.articles?.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">{a.articles.map((art) => <ArticleCard key={art.id} a={art} variant="standard" />)}</div>
        ) : <p className="text-mutedink">No published articles yet.</p>}
      </div>
    </div>
  );
}
